const API_URL = 'https://yupkart.onrender.com'
// const API_URL = 'http://localhost:5000'

export default API_URL
